/*
 *
 * StylesPage constants
 *
 */
export var SAVE_STYLE_REQUEST = 'app/StylesPage/SAVE_STYLE_REQUEST';
export var SAVE_STYLE_SUCCESS = 'app/StylesPage/SAVE_STYLE_SUCCESS';
export var SAVE_STYLE_FAILURE = 'app/StylesPage/SAVE_STYLE_FAILURE';
export var LOAD_STYLE_REQUEST = 'app/StylesPage/LOAD_STYLE_REQUEST';
export var LOAD_STYLE_SUCCESS = 'app/StylesPage/LOAD_STYLE_SUCCESS';
export var LOAD_STYLE_FAILURE = 'app/StylesPage/LOAD_STYLE_FAILURE';
export var UPDATE_DATA = 'app/StylesPage/UPDATE_DATA';
export var UPDATE_SWATCH = 'app/StylesPage/UPDATE_SWATCH';
export var UPDATE_COLOR_STYLES = 'app/StylesPage/UPDATE_COLOR_STYLES';
export var UPDATE_COLOR_STYLES_NAME = 'app/StylesPage/UPDATE_COLOR_STYLES_NAME';
export var UPDATE_TYPOGRAPHY_STYLES = 'app/StylesPage/UPDATE_TYPOGRAPHY_STYLES';
export var UPDATE_TYPOGRAPHY_STYLES_NAME = 'app/StylesPage/UPDATE_TYPOGRAPHY_STYLES_NAME';
export var UPDATE_INPUT = 'app/StylesPage/UPDATE_INPUT';
export var UPDATE_PADDING_DATA = 'app/StylesPage/UPDATE_PADDING_DATA';
export var UPDATE_TRANSITION = 'app/StylesPage/UPDATE_TRANSITION';
